<template>
  <b-row>
    <b-col>
      <h5 v-if="!loading">
        {{ ft(featureName, 'followup.messages.title', $t) }}
      </h5>
      <p
        v-if="!loading && error"
        class="text-danger d-flex align-items-center mt-5 ms-3"
      >
        <i class="bi bi-exclamation-octagon-fill fs-3 text-danger"></i>
        <span class="ms-3"> {{ error }}</span>
      </p>
      <div v-if="messages && messages.length">
        <b-row v-for="message in messages" :key="message.name">
          <b-col class="col-12 col-sm-6">
            <b-card v-if="message.from !== 'reporter'">
              <b-card-header class="d-flex justify-content-between">
                <span class="text-muted">
                  {{ message.dateCreated }}
                </span>
                <span class="text-muted">{{
                  ft(featureName, 'followup.messages.writtenByAdmin', $t)
                }}</span>
              </b-card-header>
              <b-card-body>
                {{ message.value }}
              </b-card-body>
            </b-card>
          </b-col>
          <b-col class="col-12 col-sm-6">
            <b-card v-if="message.from === 'reporter'">
              <b-card-header class="d-flex justify-content-between">
                <span class="text-muted">
                  {{ message.dateCreated }}
                </span>
                <span class="text-muted">{{
                  ft(featureName, 'followup.messages.reporter', $t)
                }}</span>
              </b-card-header>
              <b-card-body>
                {{ message.value }}
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col class="col-12 col-sm-6"> </b-col>
        <b-col v-if="!loading" class="col-12 col-sm-6">
          <textarea
            v-model="newMessageText"
            class="input-message-text"
            rows="5"
            :placeholder="ft(featureName, 'followup.messages.placeholder', $t)"
          >
          </textarea>
          <div class="d-flex justify-content-between">
            <span class="text-muted">{{
              ft(featureName, 'followup.messages.buttons.send.help', $t)
            }}</span>
            <div class="d-flex align-items-center ms-2">
              <b-button
                :disabled="!validForm"
                variant="primary"
                class="btn btn-sm btn-round"
                @click="createMessage"
              >
                {{
                  ft(featureName, 'followup.messages.buttons.send.title', $t)
                }}
              </b-button>
            </div>
          </div>
          <div class="d-flex justify-content-between"></div>
        </b-col>
        <b-col v-if="loading">
          <div class="d-flex justify-content-center m-3">
            <div class="spinner-border text-primary"></div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { DateTime } from 'luxon'
import ReporterService from '../services/ReporterService'
import LocalizableComponent from './CreateReportConfirm.vue'

export default {
  name: 'CaseMessages',
  extends: LocalizableComponent,
  props: {
    report: { type: Object, default: () => {} },
    caseName: { type: String, default: '' },
    password: { type: String, default: '' },
    organizationName: { type: String, default: '' },
    sendMessage: {
      type: Function,
      default: () => null
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newMessageText: '',
      error: null,
      loading: false
    }
  },
  computed: {
    validForm() {
      return this.newMessageText.length >= 3
    },
    messages() {
      // return [
      // {
      //   name: 'reporter',
      //   from: this.organizationName,
      //   value: 'Thanks for reaching out',
      //   date_created: new Date().toISOString()
      // }
      // ]
      return ((this.report && this.report.messages) || [])
        .map(m => ({
          ...m,
          dateCreated: DateTime.fromISO(m.date_created).toFormat(
            'yyyy-MM-dd hh:mm'
          )
        }))
        .sort((a, b) => {
          if (a.date_created < b.date_created) return -1
          if (a.date_created > b.date_created) return 1
          return 0
        })
    }
  },
  mounted() {
    this.error = null
    // if (this.caseName) {
    //   this.$store.dispatch('loadCaseMessages', this.caseName)
    // }
  },
  methods: {
    createMessage() {
      const backupText = this.newMessageText
      const payload = {
        organizationName: this.organizationName,
        caseName: this.caseName,
        password: this.password,
        value: this.newMessageText
      }

      this.error = null
      this.loading = true
      this.newMessageText = '' // ok to loose if theres an error
      return ReporterService.createCaseMessage(payload)
        .then(createdCase => {
          this.messages.push(createdCase)
          this.sendMessage()
        })
        .catch(error => {
          this.newMessageText = backupText

          const errorMessage =
            error.response && error.response.status
              ? this.ft(
                  this.featureName,
                  'messages.error.whistleblowerInfoNotFound',
                  this.$t
                )
              : error
          this.error = errorMessage
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.input-message-text {
  margin-top: 30px;
  width: 100%;
  padding: 1em;
  border: 1px solid #ced4da !important;
  border-radius: 3px;
}
</style>
